/*
 * @Author: YuanYuan
 * @Date: 2024-02-04 19:44:23
 * @LastEditTime: 2025-07-09 14:25:09
 * @description: 全局挂载 vue 实例内容
 */
import constants from '@/constants'
import api from '@/api'
import * as echarts from 'echarts/lib/echarts'
import { EffectScatterChart, LinesChart } from 'echarts/charts'

import {
  TitleComponent,
  LegendComponent,
  TooltipComponent,
  GridComponent,
  DataZoomComponent
} from 'echarts/components'


echarts.use([
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  DataZoomComponent,
  EffectScatterChart,
  LinesChart
])

export default {
  install: (Vue) => {
    Vue.prototype.$const = constants
    Vue.prototype.$api = api
    Vue.prototype.$echarts = echarts
  }
}
